import { render, staticRenderFns } from "./ZyxxForm.vue?vue&type=template&id=a017df88"
import script from "./ZyxxForm.vue?vue&type=script&lang=js"
export * from "./ZyxxForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports